// eslint-disable-next-line import/no-unresolved
import { Auth } from 'auth/services/Auth';
import { createRoot } from 'react-dom/client';

import App from './App';
import DevApp from './DevApp';

interface MountOptions {
    useDevApp?: boolean;
    basename: string;
}

const mount = (
    el: HTMLElement,
    { basename, useDevApp = false }: MountOptions,
) => {
    const root = createRoot(el);

    root.render(
        useDevApp ? (
            <DevApp basename={basename} />
        ) : (
            <App basename={basename} />
        ),
    );

    return {
        unmount: () => {
            root.unmount();
        },
    };
};
const auth = Auth.getInstance();

// window can literally be 'any' so this is a legit use of type 'any' type
/* eslint-disable  @typescript-eslint/no-explicit-any */
const theWindow = window as any;
if (theWindow.Cypress) {
    theWindow.auth = auth;
}
if (process.env.NODE_ENV === 'development') {
    const devRoot = document.querySelector('#_accounts-dev-root');
    // Assuming the container doesn't contain a '_accounts-dev-root' element.
    if (devRoot) {
        // We are running in isolation, so we mount with our localised element
        mount(devRoot as HTMLElement, {
            useDevApp: true,
            basename: '/',
        });
    }
}

export { mount };
